class Canvaselement {
    constructor(breedte, hoogte) {
        this.breedte = breedte;
        this.hoogte = hoogte;
        this.element = this.createcanvas();
        this.context = this.element.getContext('2d'); // hier pas, als het canvas bestaat
    }

    createcanvas() {
        const canvas = document.createElement('canvas');
        canvas.id = 'canvaselement';
        canvas.className = 'canvaselement';
        
        // optioneel: inline stijl (anders met CSS)
        canvas.style.width = this.breedte + 'px';
        canvas.style.height = this.hoogte + 'px';
        canvas.style.border = '1px solid #ccc';

        const dpr = window.devicePixelRatio || 1;
        canvas.width = this.breedte * dpr;
        canvas.height = this.hoogte * dpr;

        doek.element.appendChild(canvas); // zorg dat doek.element bestaat!

        return canvas;
    }
}

window.Canvaselement = Canvaselement;

export default Canvaselement;
